 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~9b75e0a7":"activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~9b75e0a7","activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~a5b076bb":"activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~a5b076bb","activate-account~login~main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-u~b60fa0f5":"activate-account~login~main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-u~b60fa0f5","activate-account":"activate-account","login":"login","main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~main-admin-users-e~451e67c3":"main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~main-admin-users-e~451e67c3","main-admin-beta-signees":"main-admin-beta-signees","main-admin-lucid":"main-admin-lucid","main-admin-studies":"main-admin-studies","main-admin-users":"main-admin-users","main-admin-users-edit":"main-admin-users-edit","main-credits-products":"main-credits-products","main-pairwise-all":"main-pairwise-all","main-session-sessions":"main-session-sessions","main-user-session-create":"main-user-session-create","main-user-session-view":"main-user-session-view","public-study":"public-study","signup":"signup","recover-password":"recover-password","slack-bind":"slack-bind","main-admin-users-create":"main-admin-users-create","main-profile-edit":"main-profile-edit","main-profile-password":"main-profile-password","reset-password":"reset-password","main-profile":"main-profile","main":"main","faq":"faq","main-admin":"main-admin","session-chat":"session-chat","social-login":"social-login","start":"start"}[chunkId]||chunkId) + "." + {"activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~9b75e0a7":"b33ec6db","activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~a5b076bb":"614b5031","activate-account~login~main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-u~b60fa0f5":"60165ba7","activate-account":"ed0a73b8","login":"431e59ab","main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~main-admin-users-e~451e67c3":"535d7cd5","main-admin-beta-signees":"c0a30b87","main-admin-lucid":"4f73dd84","main-admin-studies":"9bbf330e","main-admin-users":"86bb8075","main-admin-users-edit":"9a22d901","main-credits-products":"4be46349","main-pairwise-all":"201cf452","main-session-sessions":"d81a267a","main-user-session-create":"209bd5d4","main-user-session-view":"ede17306","public-study":"86c0491c","signup":"d3303a1c","recover-password":"ddada10b","slack-bind":"3f00aabf","main-admin-users-create":"cf3bd2c9","main-profile-edit":"8b9d4997","main-profile-password":"f0d963ad","reset-password":"2cf2da8b","main-profile":"0e19aac2","main":"d247d303","faq":"4292cb37","main-admin":"6054ff86","session-chat":"466352a0","social-login":"c2ac2d43","start":"126eac8c","chunk-2d216214":"66ac2700","chunk-47291916":"ec0607c8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~9b75e0a7":1,"activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~a5b076bb":1,"activate-account~login~main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-u~b60fa0f5":1,"activate-account":1,"login":1,"main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~main-admin-users-e~451e67c3":1,"main-admin-beta-signees":1,"main-admin-lucid":1,"main-admin-studies":1,"main-admin-users":1,"main-admin-users-edit":1,"main-credits-products":1,"main-pairwise-all":1,"main-session-sessions":1,"main-user-session-create":1,"main-user-session-view":1,"public-study":1,"signup":1,"recover-password":1,"slack-bind":1,"main-admin-users-create":1,"reset-password":1,"main-profile":1,"main":1,"faq":1,"session-chat":1,"social-login":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~9b75e0a7":"activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~9b75e0a7","activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~a5b076bb":"activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~a5b076bb","activate-account~login~main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-u~b60fa0f5":"activate-account~login~main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-u~b60fa0f5","activate-account":"activate-account","login":"login","main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~main-admin-users-e~451e67c3":"main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~main-admin-users-e~451e67c3","main-admin-beta-signees":"main-admin-beta-signees","main-admin-lucid":"main-admin-lucid","main-admin-studies":"main-admin-studies","main-admin-users":"main-admin-users","main-admin-users-edit":"main-admin-users-edit","main-credits-products":"main-credits-products","main-pairwise-all":"main-pairwise-all","main-session-sessions":"main-session-sessions","main-user-session-create":"main-user-session-create","main-user-session-view":"main-user-session-view","public-study":"public-study","signup":"signup","recover-password":"recover-password","slack-bind":"slack-bind","main-admin-users-create":"main-admin-users-create","main-profile-edit":"main-profile-edit","main-profile-password":"main-profile-password","reset-password":"reset-password","main-profile":"main-profile","main":"main","faq":"faq","main-admin":"main-admin","session-chat":"session-chat","social-login":"social-login","start":"start"}[chunkId]||chunkId) + "." + {"activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~9b75e0a7":"7033b272","activate-account~login~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~~a5b076bb":"3979d6b8","activate-account~login~main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-u~b60fa0f5":"267d66fb","activate-account":"4d712822","login":"cd0b9be1","main~main-admin-beta-signees~main-admin-lucid~main-admin-studies~main-admin-users~main-admin-users-e~451e67c3":"d02844a9","main-admin-beta-signees":"a191e0c3","main-admin-lucid":"a1563318","main-admin-studies":"27b63fb8","main-admin-users":"00e5c334","main-admin-users-edit":"76e33aea","main-credits-products":"5d2f5a1f","main-pairwise-all":"c42ffe1a","main-session-sessions":"27b63fb8","main-user-session-create":"201da577","main-user-session-view":"3f0fbf7b","public-study":"f38b075e","signup":"cc092960","recover-password":"e537a9fa","slack-bind":"2d61c344","main-admin-users-create":"f921b4fd","main-profile-edit":"31d6cfe0","main-profile-password":"31d6cfe0","reset-password":"95fd7b3f","main-profile":"981130b2","main":"b6728570","faq":"98f45a23","main-admin":"31d6cfe0","session-chat":"3a533b69","social-login":"fd3b04cd","start":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-47291916":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
